import { render, staticRenderFns } from "./CommodityManagementHospitalVer.vue?vue&type=template&id=bb2eb2ec&scoped=true"
import script from "./CommodityManagementHospitalVer.vue?vue&type=script&lang=js"
export * from "./CommodityManagementHospitalVer.vue?vue&type=script&lang=js"
import style0 from "./CommodityManagementHospitalVer.vue?vue&type=style&index=0&id=bb2eb2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-load_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2eb2ec",
  null
  
)

export default component.exports